module.exports = __webpack_public_path__ + "img/9788932909509.7fe9f2ce.jpg";